import { createListenerMiddleware } from "@reduxjs/toolkit";

const listenerMiddleware = createListenerMiddleware();

let bucket = [];

listenerMiddleware.startListening({
  predicate: (action, currState, prevState) => true,
  effect: async (action, listenerApi) => {
   
    const meta = action.meta;
    const args = meta?.arg ?? {};
    const requestStatus = meta?.requestStatus;
    const isAsyncFunction = !!requestStatus;
    const aborted = meta?.aborted ?? false;
    const requestId = meta?.requestId;

    if (isAsyncFunction === true) {
      if (requestStatus === "pending") {
        bucket.push({ id: requestId, name: action.type });
      } else if (requestStatus !== "pending") {
        /* fullfiled or rejected logic */
        bucket = [...bucket].filter((element) => element.id !== requestId);
        if (requestStatus === "fulfilled") {
          /*fullfiled logic*/
         
        }
        if (requestStatus === "rejected") {
          /* rejected logic */
          const aborted = meta?.aborted ?? false;
          if (aborted === true) {
            /*aborted logic*/
          } else if (aborted !== true) {
            /* not aborted logic */
          }
        }
      }

    } else if (isAsyncFunction === false) {
      /* sync logic */
    }
  },
});



export default listenerMiddleware;
